import { render, staticRenderFns } from "./CustomSignage.vue?vue&type=template&id=110fb2e2&scoped=true&"
import script from "./CustomSignage.vue?vue&type=script&lang=ts&"
export * from "./CustomSignage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110fb2e2",
  null
  
)

export default component.exports